import { FC, HTMLAttributes } from "react";
import { ReactComponent as CloseIconSvg } from "../../images/CrossIcon.svg";
import cn from "classnames";
import styles from "./Modal.module.sass";

interface ModalProps extends HTMLAttributes<HTMLDivElement> {
	handleClose: () => void;
	transparent?: boolean;
}

const Modal: FC<ModalProps> = ({ handleClose, transparent = true, className, children }) => {
	return (
		<div className={cn(styles.wrapper, { [styles.blur]: transparent })} onClick={transparent ? handleClose : () => {}}>
			<div className={cn(styles.modal, className)} onClick={(e) => e.stopPropagation()}>
				<CloseIconSvg className={styles.closeIcon} onClick={handleClose} />
				{children}
			</div>
		</div>
	);
};

export default Modal;
